export const FLOW_CONTROL_PIECE_NAME = '@activepieces/piece-flow-control';

export function isFlowControlStep(pieceName: string): boolean {
    return pieceName === FLOW_CONTROL_PIECE_NAME;
}